module.exports = __webpack_public_path__ + "static/img/207.40de81b.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/207.png
// module id = 506
// module chunks = 3